'use client';

import { useParams, usePathname } from 'next/navigation';

import NavTab from '#/components/tabs/nav-tab';
import { MenuItems } from '#/data/menu';
import { useLocale } from '#/i18n/client';

import type { UserProfile } from '#/lib/account';
import { useSaenggibuSeen } from '#/lib/saenggibu/seen';

export default function TryTab({ user }: { user?: UserProfile }) {
  const pathname = usePathname();
  const params = useParams();
  const locale = useLocale();

  const saenggibuSeen = useSaenggibuSeen();
  const routes = MenuItems(params, pathname || '', locale, saenggibuSeen);

  const current = routes.find((v) => v.active);

  const filterCurrent = current?.children?.filter((e) => {
    if (e.permissions.length === 0) return true;
    return e.permissions.some((perm) =>
      (user?.adminRole?.permissions as string[] | undefined)?.includes(perm)
    );
  });

  return (
    <div className="flex-1 flex flex-wrap justify-between gap-2">
      <NavTab items={filterCurrent ?? []} />
      {/* {!pathname.includes(ROUTES.CUSTOM_DICT) && (
        <SpellerCount user={user} pathname={pathname} wallet={wallet} />
      )} */}
    </div>
  );
}
